import { Injectable } from '@angular/core';
import { RxdbService } from 'src/app/services/rxdb.service';
import RxDB from 'rxdb';
import { AuthenticationSchemaDocType } from 'src/app/rxdb-schema/authentication.schema';

@Injectable({
  providedIn: 'root'
})

export class AuthFacade {
  constructor(private rxDB: RxdbService) {}

  insertDataToDB(data: AuthenticationSchemaDocType) {
    if(data.agent_id === undefined) return;
    this.rxDB.db.auth.atomicUpsert({
      agent_id: data.agent_id.toString(),
      access_token: data.access_token,
      agency_id: data.agency_id,
      contact_id: data.contact_id,
      expires_in: data.expires_in,
      jti: data.jti,
      max_idle: data.max_idle,
      participant_ids: data.participant_ids,
      program_ids: data.program_ids,
      refresh_token: data.refresh_token,
      scope: data.scope,
      token_type: data.token_type
    });
  }

  getDataFromDB(id?: string) {
    if (id !== undefined) {
      return this.rxDB.db.auth.findOne().where('agent_id').eq(id).exec();
    }
    return this.rxDB.db.auth
    .findOne()
    .exec();
  }

  deleteDataToDB() {
    this.rxDB.db.auth.remove();
  }
}
